module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "c-card"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__header__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.catalog_category_list.header_title')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-category-list"
  }, [_vm._l((_vm.$store.getters.categories), function(category, i) {
    return [(category.code) ? _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: 'Rewards Results',
          query: {
            category: category.code
          }
        }
      }
    }, [_c('category-list-tile', {
      attrs: {
        "category": category
      }
    })], 1) : _vm._e(), _vm._v(" "), (category.page_id) ? _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: 'Page_' + category.page_id
        }
      }
    }, [_c('category-list-tile', {
      attrs: {
        "category": category
      }
    })], 1) : _vm._e(), _vm._v(" "), (category.reward_id) ? _c('router-link', {
      key: i,
      attrs: {
        "to": {
          name: 'Single Reward',
          params: {
            id: category.reward_id
          }
        }
      }
    }, [_c('category-list-tile', {
      attrs: {
        "category": category
      }
    })], 1) : _vm._e(), _vm._v(" "), (!category.code && !category.page_id && !category.reward_id) ? _c('category-list-tile', {
      key: i,
      staticClass: "is-not-linked",
      attrs: {
        "category": category
      }
    }) : _vm._e()]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62d7cc6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/catalog/CategoryList.vue
// module id = 543
// module chunks = 1